import DetailsBadge from './DetailsBadge';

export default DetailsBadge;
